<template>
  <div>
    <div class="input-group input-group-sm">
    <span class="form-control is-disabled" v-if="!isMutable">{{value}}</span>
    <input type="text" v-if="isMutable"
      class="form-control"
      :class="{'validated-control': validated, 'is-invalid': !valid}"
      ref="input"
      :id="elementId"
      v-bind:value="value"
      :name="elementId"
      :readonly="readOnly"
      @keypress="handleKeyPress"
      @keyup="handleKeyUp"
      @blur="validate"
      :required="isRequired"/>
    <div class="input-group-append">
      <span class="input-group-text">%</span>
    </div>
  </div>
  <div class="error-feedback" v-if="!valid">
    <ul>
      <li v-for="error in errors" v-bind:key="error">{{error}}</li>
    </ul>
  </div>
  </div>
</template>

<script>

export default {
  name: 'percent-input',
  props: ['value', 'required', 'field', 'addOnCaption', 'id', 'validated', 'disabled', 'lt', 'gt', 'readOnly'],
  data: () => ({
    valid: true,
    errors: []
  }),
  watch: {
    'value': function(value) {
      this.formatValue(value)
    }
  },
  computed: {
    elementId: function () {
      if (this.field) {
        return this.field.id
      } else {
        return this.id
      }
    },
    isRequired: function () {
      if (this.field) {
        return this.field.required
      } else {
        return this.required
      }
    },
    isMutable: function () {
      if (this.disabled) {
        return false
      } else if (this.field) {
        return this.field.mutable
      } else {
        return true
      }
    }
  },
  methods: {
    sendClickEvent: function () {
      this.$emit('addOnClicked', '')
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    handleKeyPress: function(e) {

      if (e.key === 'Delete') {
        return
      } else if (e.key == 'Backspace') {
        return
      } else if (!this.isNumeric(e.key) && e.key !== '.' && e.key !== '%') {
        e.preventDefault()
      }

    },
    validate: function (e) {

      this.$emit('blur', e)

    },
    formatValue: function (currentString) {

      if (!currentString) {
        return
      }
      let baseString = ''

      for (var i = 0; i < currentString.length; i++) {
        let char = currentString.charAt(i)

        if (this.isNumeric(char) || char === '.' || char === '%') {
          baseString = baseString + char
        }
      }
      this.$emit('input', baseString)
    },
    handleKeyUp: function (e) {
      this.formatValue(e.target.value)
    }
  },
  mounted () {
    this.formatValue(this.value)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

span.is-disabled {
  background-color: #EEEEEE;
}

.error-feedback {
  color: red;
  font-size: 8pt;
}

</style>
